import { Component, inject, input } from '@angular/core';
import {
    SectionCard,
    SectionCardComponent,
} from './section-card/section-card.component';
import { FollowCursorComponent } from '../common/follow-cursor/follow-cursor.component';
import { LanguageSelectionComponent } from '../common/language-selection/language-selection.component';
import { DOMHandlerService } from '../../services/domhandler.service';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-start',
    imports: [
        FollowCursorComponent,
        SectionCardComponent,
        LanguageSelectionComponent,
        NgClass,
    ],
    templateUrl: './start.component.html',
})
export class StartComponent {
    data = input.required<Start>();
    isColReverse = Math.random() < 0.5;
    domhandler = inject(DOMHandlerService);
}

type Start = {
    left: SectionCard;
    right: SectionCard;
};
